
.ll,
.ll *,
.ll *::before,
.ll *::after {
  box-sizing: border-box;
}

.ll {
  position: relative;
  background: #ffffff;
  color: #0a0a0a;
  font-family: "Rajdhani", Arial, sans-serif;
  overflow: hidden;
}

.ll-inner {
  max-width: 1200px;
  margin: 0 auto;
}

.ll-header {
  text-align: left;
  max-width: 760px;
  margin: 0 0 3rem 0;
}

.ll-eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 0.75rem;
  font-weight: 600;
  font-size: 0.8rem;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  color: #de3431;
  margin-bottom: 1.25rem;
}

.ll-eyebrow-mark {
  width: 28px;
  height: 2px;
  background: #de3431;
  border-radius: 2px;
  display: inline-block;
}

.ll-title {
  margin: 0 0 1rem 0;
  font-weight: 700;
  font-size: clamp(2rem, 3.5vw, 2.5rem);
  letter-spacing: -0.025em;
  line-height: 1.1;
  color: #0a0a0a;
}

.ll-title-accent {
  background: linear-gradient(135deg, #de3431 0%, #ff6b5a 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  color: transparent;
}

.ll-subtitle {
  margin: 0;
  font-size: clamp(1rem, 1.1vw, 1.1rem);
  line-height: 1.55;
  color: #4a4a55;
  font-weight: 500;
}

.ll-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 1.5rem;
  align-items: stretch;
}

.ll-card {
  position: relative;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border: 1px solid rgba(10, 10, 10, 0.08);
  border-radius: 14px;
  padding: 1.6rem 1.6rem 1.7rem;
  box-shadow: 0 2px 12px rgba(10, 10, 10, 0.04);
  transition: border-color 0.25s ease, box-shadow 0.25s ease, transform 0.25s ease;
}

.ll-card:hover {
  border-color: rgba(222, 52, 49, 0.35);
  box-shadow: 0 18px 38px rgba(222, 52, 49, 0.1), 0 4px 14px rgba(10, 10, 10, 0.05);
  transform: translateY(-3px);
}

.ll-card-featured {
  border-color: rgba(222, 52, 49, 0.55);
  box-shadow: 0 14px 30px rgba(222, 52, 49, 0.14), 0 4px 12px rgba(10, 10, 10, 0.05);
  background: linear-gradient(180deg, #ffffff 0%, #fff8f7 100%);
}

.ll-card-featured:hover {
  border-color: rgba(222, 52, 49, 0.75);
  box-shadow: 0 22px 44px rgba(222, 52, 49, 0.18), 0 6px 16px rgba(10, 10, 10, 0.06);
}

.ll-card-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 0.75rem;
}

.ll-card-label {
  font-size: 0.75rem;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  font-weight: 700;
  color: rgba(10, 10, 10, 0.55);
}

.ll-card-flag {
  font-size: 0.7rem;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  font-weight: 700;
  color: #ffffff;
  background: #de3431;
  padding: 0.22rem 0.55rem;
  border-radius: 999px;
}

.ll-card-vram {
  font-size: clamp(1.85rem, 2.4vw, 2.2rem);
  font-weight: 700;
  letter-spacing: -0.02em;
  line-height: 1;
  color: #0a0a0a;
}

.ll-card-config {
  margin-top: 0.4rem;
  font-size: 0.95rem;
  font-weight: 600;
  color: #de3431;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.ll-card-usecase {
  margin: 1.2rem 0 0.5rem 0;
  font-size: 1.15rem;
  font-weight: 700;
  letter-spacing: -0.005em;
  color: #0a0a0a;
  line-height: 1.25;
}

.ll-card-summary {
  margin: 0 0 1.1rem 0;
  font-size: 0.98rem;
  line-height: 1.5;
  color: #4a4a55;
  font-weight: 500;
}

.ll-card-models {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 0.55rem;
  border-top: 1px solid rgba(10, 10, 10, 0.07);
  padding-top: 1.1rem;
}

.ll-card-model {
  position: relative;
  display: flex;
  align-items: flex-start;
  gap: 0.6rem;
  font-size: 0.95rem;
  line-height: 1.35;
  color: #2a2a32;
  font-weight: 500;
}

.ll-card-model-bullet {
  flex-shrink: 0;
  width: 6px;
  height: 6px;
  margin-top: 0.55rem;
  border-radius: 999px;
  background: #de3431;
}

.ll-card-shop {
  margin-top: 1.25rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.65rem 1rem;
  text-decoration: none;
  font-family: "Rajdhani", Arial, sans-serif;
  font-weight: 700;
  font-size: 0.85rem;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #de3431;
  background: transparent;
  border: 2px solid #de3431;
  border-radius: 4px;
  transition: background 0.2s ease, color 0.2s ease, border-color 0.2s ease;
}

.ll-card-shop:hover,
.ll-card-shop:focus-visible {
  background: #de3431;
  color: #ffffff;
}

.ll-card-shop-arrow {
  display: inline-block;
  transition: transform 0.2s ease;
}

.ll-card-shop:hover .ll-card-shop-arrow,
.ll-card-shop:focus-visible .ll-card-shop-arrow {
  transform: translateX(3px);
}

.ll-card-featured .ll-card-shop {
  background: #de3431;
  color: #ffffff;
}

.ll-card-featured .ll-card-shop:hover,
.ll-card-featured .ll-card-shop:focus-visible {
  background: #0a0a0a;
  border-color: #0a0a0a;
}

.ll-footer {
  margin-top: 2.5rem;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 1.25rem;
  padding: 1.4rem 1.6rem;
  border: 1px solid rgba(10, 10, 10, 0.08);
  border-radius: 12px;
  background: #fafafb;
}

.ll-footer-note {
  margin: 0;
  font-size: 1rem;
  line-height: 1.45;
  color: #2a2a32;
  font-weight: 500;
  max-width: 640px;
}

.ll-footer-cta {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1.4rem;
  background: #de3431;
  color: #ffffff;
  text-decoration: none;
  font-family: "Rajdhani", Arial, sans-serif;
  font-weight: 700;
  font-size: 0.95rem;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  border: 2px solid #de3431;
  border-radius: 4px;
  transition: background 0.2s ease, color 0.2s ease, border-color 0.2s ease;
  flex-shrink: 0;
}

.ll-footer-cta:hover,
.ll-footer-cta:focus-visible {
  background: #0a0a0a;
  color: #ffffff;
  border-color: #0a0a0a;
}

.ll-footer-cta-icon {
  display: inline-block;
  flex-shrink: 0;
}

.ll-footer-cta-wrap {
  position: relative;
  display: inline-flex;
  flex-shrink: 0;
}

.ll-footer-cta-tooltip {
  position: absolute;
  bottom: calc(100% + 10px);
  left: 50%;
  transform: translateX(-50%) translateY(4px);
  background: rgba(10, 10, 10, 0.95);
  color: #ffffff;
  padding: 0.5rem 0.8rem;
  border-radius: 6px;
  font-family: "Rajdhani", Arial, sans-serif;
  font-size: 0.85rem;
  font-weight: 500;
  letter-spacing: 0.01em;
  white-space: nowrap;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.18s ease, transform 0.18s ease;
  box-shadow: 0 8px 20px rgba(10, 10, 10, 0.22);
  z-index: 5;
}

.ll-footer-cta-tooltip::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  border: 5px solid transparent;
  border-top-color: rgba(10, 10, 10, 0.95);
}

.ll-footer-cta-wrap:hover .ll-footer-cta-tooltip,
.ll-footer-cta:focus-visible ~ .ll-footer-cta-tooltip {
  opacity: 1;
  transform: translateX(-50%) translateY(0);
}

@media (max-width: 1000px) {
  .ll-grid {
    grid-template-columns: 1fr;
    gap: 1.1rem;
  }

  .ll-header {
    margin-bottom: 2rem;
  }
}

@media (max-width: 600px) {
  .ll-card {
    padding: 1.3rem 1.25rem 1.4rem;
  }

  .ll-card-vram {
    font-size: 1.65rem;
  }

  .ll-card-usecase {
    font-size: 1.05rem;
  }

  .ll-card-summary {
    font-size: 0.94rem;
  }

  .ll-footer {
    padding: 1.1rem 1.2rem;
    flex-direction: column;
    align-items: flex-start;
  }

  .ll-footer-cta {
    width: 100%;
    justify-content: center;
  }
}
